import { render, staticRenderFns } from "./BlogCommentEdit.vue?vue&type=template&id=634223be&scoped=true&"
import script from "./BlogCommentEdit.vue?vue&type=script&lang=js&"
export * from "./BlogCommentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634223be",
  null
  
)

export default component.exports